'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _Immutable = require('Immutable');

var _TimezoneGroups = require('../lists/TimezoneGroups');

var _TimezoneGroups2 = _interopRequireDefault(_TimezoneGroups);

var _TimezoneBlacklist = require('../lists/TimezoneBlacklist');

var _TimezoneBlacklist2 = _interopRequireDefault(_TimezoneBlacklist);

var _TimezoneGroup = require('../records/TimezoneGroup');

var _TimezoneGroup2 = _interopRequireDefault(_TimezoneGroup);

var _Timezone = require('../records/Timezone');

var _Timezone2 = _interopRequireDefault(_Timezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_CITIES_IN_GROUP_NAME = 4;

exports.default = function (timezoneAliases) {
  return new _TimezoneGroups2.default((0, _Immutable.List)(_I18n2.default.moment.tz.names()).filter(function (name) {
    return name.search(/GMT/g) < 0 && name.search(/Etc/g) < 0 && name.search(/\//g) > -1 && !_TimezoneBlacklist2.default.includes(name);
  }).groupBy(function (name) {
    return name.split('/')[0];
  }).map(function (timezonesByArea, area) {
    return new _TimezoneGroup2.default({
      groupName: _I18n2.default.text('timezone_utils.regions.' + area.toLowerCase()),
      timezones: timezonesByArea.groupBy(function (timezoneName) {
        var momentTimezone = _I18n2.default.moment.tz.zone(timezoneName);

        var untils = new _Immutable.List(momentTimezone.untils);
        var offsets = new _Immutable.List(momentTimezone.offsets);
        var futureTransitions = untils.filter(function (until) {
          return until > _I18n2.default.moment().valueOf();
        });

        var futureOffsets = offsets.takeLast(futureTransitions.size);

        return futureTransitions.filter(function (transition) {
          return transition !== Infinity;
        }).concat(futureOffsets).hashCode();
      }).toList().map(function (momentTimezones) {
        var aliasWithTimezoneInGroup = function aliasWithTimezoneInGroup(alias) {
          return alias.timezones.some(function (timezone) {
            return momentTimezones.includes(timezone);
          });
        };

        var alias = timezoneAliases.find(aliasWithTimezoneInGroup);
        var cityNames = momentTimezones.map(function (timezone) {
          return timezone.split('/').pop().toLowerCase();
        }).toArray();

        var offset = _I18n2.default.moment.tz(momentTimezones.first()).format('Z');

        var translatedCityNames = cityNames.map(function (name) {
          return _I18n2.default.text('timezone_utils.cities.' + name);
        });

        var name = alias ? alias.name : _I18n2.default.formatList(translatedCityNames.slice(0, MAX_CITIES_IN_GROUP_NAME));
        return new _Timezone2.default({ offset: offset, momentTimezones: momentTimezones, name: name });
      })
    });
  }).toList());
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/timezone-utils/static-2.97/js/helpers/computeTimezoneGroups.js
// module id = 229
// module chunks = 0